import React, { useState, useEffect } from 'react';

const CenterFloatingBoxWidget = ({ selectedLayout, isTemplateId, widgetId, updateCookieConsentTabData,cookieConsentTabData }) => {
    const [isClosePopupWidget, setIsClosePopupWidget] = useState(true);

    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/cookie-consent/temp-css/CookieConsentWidget.css`;
        if (widgetId) {
            link.setAttribute("cookie-consent-data-dynamic-css", "cookie-consent");
        } else {
            link.setAttribute("data-dynamic-css", "cookie-consent");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="cookie-consent"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

    const {
        is_website_frontend,
        postion_type,
        message,
        policy_display_type,
        policy_url,
        policy_link_text,
        compliance_type,
        is_show_confirmation_button,
        confirmation_button_text,
        allow_button_text,
        background_color,
        text_color,
        link_color,
        confirmation_button_background_color,
        allow_button_color,
        text_font_size,
    } = cookieConsentTabData || {};

    // Function to toggle the popup and show it again after 3seconds if hidden
    const toggleClosePopupWidget = () => {
        setIsClosePopupWidget(false); 

        // Show popup again after 3 seconds
        setTimeout(() => {
            setIsClosePopupWidget(true);
        }, 3000);
    };

    return (
        <div className={`cookie_main upgadeify cookie-consent-center-floating-box-widget-temp ${is_website_frontend}`}>
            {isClosePopupWidget && (
                <div className={`floating_box centerfloating_box cookie_topmain ${postion_type}`} style={{ backgroundColor: background_color }}>

                    {/* Message and Optional Policy Link */}
                    <div className="cookie_text">
                        <div style={{ color: text_color, fontSize: text_font_size }}>{message}</div>
                        {policy_display_type === 'Show_Policy_link' && (
                            <a
                                href={policy_url}
                                style={{ color: link_color, fontSize: text_font_size, fontWeight: 900 }}
                            >
                                {policy_link_text}
                            </a>
                        )}
                    </div>

                    {/* Hide/Allow Cookies Compliance Type */}
                    {compliance_type === 'Hide_Allow_Cookies' && (
                        Number(is_show_confirmation_button) === 0 ? (
                            <div className='cookie_btn'>
                                <button onClick={toggleClosePopupWidget}
                                    className='cookie_btn_accept'
                                    style={{ color: "#000", backgroundColor: confirmation_button_background_color, fontSize: text_font_size }}
                                >
                                    {confirmation_button_text}
                                </button>
                            </div>
                        ) : (
                            <button onClick={toggleClosePopupWidget} className="cookie_close" style={{ color: text_color,fontSize: text_font_size }}>X</button>
                        )
                    )}

                    {/* Show/Allow Cookies Compliance Type */}
                    {compliance_type === 'Show_Allow_Cookies' && (
                        <div className="cookie_buttons">
                            <button 
                                onClick={toggleClosePopupWidget}
                                className="btn_cookie"
                                style={{ color: "#000", backgroundColor: allow_button_color, fontSize: text_font_size }}
                            >
                                {allow_button_text}
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default CenterFloatingBoxWidget;
